angular.module('tgaAdmin')
  .service('placeholderDataService', [
    '$translate',
    function ($translate) {
      this.setJeopardyPlaceholder = function (data) {
        data.text = $translate.instant('game.jeopardy.placeholder_clue').toString();
        data.answer_phrase = $translate.instant('game.jeopardy.placeholder_phrase').toString();
        data.answers.forEach((item, i) => {
          if (i) {
            item.text = $translate.instant('game.jeopardy.placeholder_incorrect').toString();
            item.correct = false;
          } else {
            item.text = $translate.instant('game.jeopardy.placeholder_correct').toString();
            item.correct = true;
          }
        });
        return data;
      };

      this.setNoodlePlaceholder = function (data) {
        data.body = $translate.instant('game.noodle.category_default').toString();
        data.text = $translate.instant('game.noodle.prompt_default').toString();
        data.answer_phrase = $translate.instant('game.noodle.answer_default').toString();
        return data;
      };
    },
  ]);
